export const locale = {
    lang: 'ds',
    data: {
        'TITLE': {
        },
        'FIELDS': {
            'CoworkerRate': 'medarbejderløn',
        },
        'Message': {

        },
        'FILTERS': {
        },
        'Buttons': {
            'Save': 'Gem',
        }
    }
};